import {Helmet} from 'react-helmet-async';
import '../components/InformationPage.css';

function PrivacyPolicyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Medical Coding Classes Online</title>
        <meta
          name="description"
          content="Read the Medical Coding Classes Online privacy policy covering local study progress, analytics, communications, and user data protection."
        />
        <link rel="canonical" href="https://medicalcodingclassesonline.com/privacy" />
      </Helmet>
      <main className="information-page">
        <section className="information-hero">
          <div className="container">
            <span className="eyebrow">Privacy and data</span>
            <h1>Privacy Policy</h1>
            <p>
              This policy explains how Medical Coding Classes Online handles information when
              visitors use the website and its study tools.
            </p>
          </div>
        </section>
        <section className="information-section">
          <div className="container information-layout">
            <article className="information-content">
              <h2>1. Information we collect</h2>
              <p>
                We may receive information that you voluntarily provide when you contact us,
                including your name, email address, and the contents of your message. We do not
                require an account or sign-up to use the curriculum.
              </p>
              <h2>2. Local study progress</h2>
              <p>
                Completed lessons and selected study preferences may be stored in your browser
                using local storage. This allows the site to remember progress on the same browser
                and device. Local storage data is not an account record and may be removed when you
                clear browser data, use a different device, or use private browsing.
              </p>
              <h2>3. Analytics and technical information</h2>
              <p>
                We may use analytics and similar technical tools to understand site performance,
                page usage, device type, browser type, approximate location, and referral
                information. These tools help us improve content, accessibility, reliability, and
                the learning experience.
              </p>
              <p>
                Analytics providers may use cookies or comparable technologies according to their
                own policies. Browser settings may allow you to limit or block cookies.
              </p>
              <h2>4. How information is used</h2>
              <ul>
                <li>To provide, maintain, and improve the website and study tools.</li>
                <li>To respond to support requests and other communications.</li>
                <li>To monitor security, prevent misuse, and troubleshoot technical problems.</li>
                <li>To understand aggregate usage trends without identifying individual learners.</li>
              </ul>
              <h2>5. Sharing and service providers</h2>
              <p>
                We do not sell personal information. Information may be shared with service
                providers that help operate the website, forms, analytics, hosting, security, or
                communications. Providers are expected to use information only to perform the
                services they provide.
              </p>
              <h2>6. Data protection and retention</h2>
              <p>
                We use reasonable administrative, technical, and organizational safeguards to
                protect information. No online system can guarantee absolute security. We retain
                support communications for as long as reasonably necessary to respond, maintain
                records, resolve disputes, and meet legal obligations.
              </p>
              <h2>7. Children and educational use</h2>
              <p>
                The website is intended for general educational use and is not directed to children
                under 13. We do not knowingly collect personal information from children under 13.
              </p>
              <h2>8. Your choices and rights</h2>
              <p>
                Depending on where you live, you may have rights to request access, correction,
                deletion, or information about how your personal data is used. You may also clear
                local storage and adjust browser cookie controls. To ask a privacy question,
                contact <a href="mailto:support@leadsurance.com">support@leadsurance.com</a>.
              </p>
              <h2>9. Policy updates</h2>
              <p>
                We may update this policy as the website, technology, or legal requirements
                change. The updated version will be posted on this page with a revised date when
                appropriate.
              </p>
            </article>
            <aside className="information-aside">
              <span className="aside-label">Privacy questions</span>
              <h2>Need more information?</h2>
              <p>
                Contact Leadsurance for questions about this policy or information submitted
                through the site.
              </p>
              <a href="mailto:support@leadsurance.com">Email support</a>
            </aside>
          </div>
        </section>
      </main>
    </>
  );
}

export default PrivacyPolicyPage;